import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import React, { Fragment } from "react";
import { Card, Form, Input, Label } from "reactstrap";
import { Btn, H4, LI, UL } from "../../../AbstractElements";
import { Cancel, Messages, NewMessage, Save, Send, Subject, To } from "../../../Constant";
import CommonFileUpload from "../../Common/CommonFileUpload";

const ComposeMessage = () => {
  const getUploadParams = ({ meta }) => {
    return {
      url: "https://httpbin.org/post",
    };
  };
  const handleChangeStatus = ({ meta, file }, status) => {};
  return (
    <Fragment>
      <div className="email-right-aside">
        <Card className="email-body">
          <div className="email-profile compose-mail">
            <div className="email-body">
              <div className="email-compose">
                <div className="email-top compose-border">
                  <div className="compose-header">
                    <H4 className="mb-0">{NewMessage}</H4>
                    <Btn color="primary" type="button">
                      <i className="fa fa-file me-2"></i> {Save}
                    </Btn>
                  </div>
                </div>
                <div className="email-wrapper">
                  <Form className="theme-form">
                    <div className="form-group">
                      <Label className="col-form-label pt-0">{To}</Label>
                      <Input className="form-control" id="exampleInputEmail1" type="email" />
                    </div>
                    <div className="form-group">
                      <Label className="col-form-label pt-0">{Subject}</Label>
                      <Input className="form-control" id="exampleInputPassword1" type="text" />
                    </div>
                    <div className="form-group mb-4">
                      <Label className="col-form-label pt-0">{Messages}</Label>
                      <CKEditor editor={ClassicEditor} data={"Hello!, This is content."} />
                    </div>
                    <div className="form-group">
                      <CommonFileUpload />
                    </div>
                  </Form>
                  <div className="action-wrapper">
                    <UL className="simple-list actions d-flex justify-content-end">
                      <LI>
                        <Btn type="button">
                          <i className="fa fa-paper-plane me-2" />
                          {Send}
                        </Btn>
                      </LI>
                      <LI>
                        <Btn color="danger" type="button">
                          <i className="fa fa-times me-2"></i>
                          {Cancel}
                        </Btn>
                      </LI>
                    </UL>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </Fragment>
  );
};
export default ComposeMessage;
